import React from "react";
import { Box, Grid, Typography } from "@mui/material";

const PlaceOrderGuide = () => {
  const cardInfo = [
    { title: "1. ثبت نام", subtitle: "میبایست سجامی باشید" },
    { title: "2. تایید عضویت", subtitle: "تا یک روز کاری" },
    { title: "3. واریز وجه", subtitle: "از طریق کارت بانکی بنام خریدار" },
    { title: "4. ثبت درخواست", subtitle: "خرید یا فروش" },
    {
      title: "5. تایید و انجام سفارش",
      subtitle: "می توانید دارایی خود را مشاهده کنید",
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: "white",
        px: 6,
        pb: 2,
        pt: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 5,
        borderRadius: "24px",
        width: "100%",
        mx: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "1.5rem",
              md: "1.7rem",
            },
            color: "#666565",
            fontWeight: 500,
          }}
        >
          فرایند ثبت سفارش
        </Typography>

        <Box
          component="img"
          src={"/media/image/fingerDown.svg"}
          alt="finger down"
          sx={{
            width: 30,
            height: 30,
            objectFit: "contain",
          }}
        />
      </Box>

      <Grid container spacing={3}>
        {cardInfo.map((item, index) => {
          const isLast = index === cardInfo.length - 1;
          const isOdd = cardInfo.length % 2 !== 0;

          return (
            <Grid
              item
              xs={12}
              sm={isLast && isOdd ? 12 : 6}
              xl={2.4}
              key={item.title}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                  px: 3,
                  py: 2,
                  boxShadow: "inset 0px 4px 27.5px 0px #0000002E",
                }}
              >
                <Box
                  component="img"
                  src={"/media/image/star.svg"}
                  alt="star"
                  sx={{
                    width: 25,
                    height: 25,
                    objectFit: "contain",
                  }}
                />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    textAlign: {
                      sm: isLast && isOdd ? "center" : "left",
                      xl: "left",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "1.125rem",
                      color: "#666565",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.title}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: 12, sm: 14 },
                      color: "#b9b9b9",
                      fontWeight: 400,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.subtitle}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default PlaceOrderGuide;
